import { render } from "./PackageInfoTable.vue?vue&type=template&id=0dba6a04&scoped=true"
import script from "./PackageInfoTable.vue?vue&type=script&lang=js"
export * from "./PackageInfoTable.vue?vue&type=script&lang=js"

import "./PackageInfoTable.vue?vue&type=style&index=0&id=0dba6a04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dba6a04"]])

export default __exports__